import { createAction, props } from '@ngrx/store'
import { Room } from './rooms.model'
import { Update } from '@ngrx/entity'

export const GetRooms = createAction('[Rooms] Get', props<{ rentalId: string }>())
export const GetRoomsComplete = createAction('[Rooms] Get Complete', props<{ rooms: Room[] }>())

export const UpdateRoom = createAction('[Rooms] Update', props<{ room: Partial<Room>; silent?: boolean }>())
export const UpdateRoomComplete = createAction('[Rooms] Update Complete', props<{ update: Update<Room> }>())

export const UpsertRooms = createAction(
  '[Rooms] Upsert Rooms',
  props<{ createRooms: Partial<Room>[]; updateRooms: Partial<Room>[] }>()
)
export const UpsertRoomsComplete = createAction('[Rooms] Upsert Rooms Complete', props<{ rooms: Room[] }>())

export const DeleteRoom = createAction('[Rooms] Delete', props<{ room: Room }>())
export const DeleteRoomComplete = createAction('[Rooms] Delete Complete', props<{ room: Room }>())
